import { atom } from 'jotai';

export const formDataAtom = atom({});

export const formErrorAtom = atom(false);

export const handleFormDataUpdateAtom = atom(null, (_, set, update: any) => {
  set(formDataAtom, (prev) => ({ ...prev, ...update }));
});

export const handleFormErrorAtom = atom(null, (get, set) => {
  const current = get(formErrorAtom);

  if (!current) {
    set(formErrorAtom, true);
  }
});
